export default __webpack_public_path__ + "static/eth-newdelhi-b4a10f84a70895a1df30266fa5824f40.svg";